import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDateTime } from "utils/localizations";
import type PayGateRefundDetailViewModel from "viewModels/finance/refundApprovals/payGateRefunds/payGateRefundDetailViewModel";
import Section from "../../../common/section";

const PayGateOrderSectionView: ViewComponent<PayGateRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <Section title={vm.translate("order.title")} context={vm.item.charge}>
      <Row>
        <Form.Group as={Col} xs={12} className="mb-3">
          <Form.Label>{vm.translateModelAttribute("charge", "vehicle")}</Form.Label>
          <FakeInput
            target={vm.item.charge ? vm.item.charge.vehicle : undefined}
            property="licensePlate"
            valueFormatter={(licensePlate: string) =>
              licensePlate && vm.item.charge ? `${vm.countryCode(vm.item.charge.vehicle.countryId)} - ${licensePlate}` : undefined
            }
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} md={12} lg={6} className="mb-3">
          <Form.Label>{vm.translateModelAttribute("charge", "chargeTypeId")}</Form.Label>
          <FakeInput
            target={vm.item.charge}
            property="priceListItemId"
            valueFormatter={(priceListItemId: string) => vm.chargeType(priceListItemId)}
          />
        </Form.Group>
        <Form.Group as={Col} md={12} lg={6} className="mb-3">
          <Form.Label>{vm.translateModelAttribute("charge", "price")}</Form.Label>
          <FakeInput target={vm.item.charge} property="price" valueFormatter={(price: number) => formatAmount(price)} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} lg={6} xl={12} className="mb-3">
          <Form.Label>{vm.translateModelAttribute("charge", "validSince")}</Form.Label>
          <FakeInput target={vm.item.charge} property="validSince" valueFormatter={(date: Date) => formatDateTime(date)} />
        </Form.Group>
        <Form.Group as={Col} lg={6} xl={12} className="mb-3">
          <Form.Label>{vm.translateModelAttribute("charge", "validUntil")}</Form.Label>
          <FakeInput target={vm.item.charge} property="validUntil" valueFormatter={(date: Date) => formatDateTime(date)} />
        </Form.Group>
      </Row>
    </Section>
  );
});

export default PayGateOrderSectionView;
